import { isUserAdmin, isUserSupport, userPrivileges } from "constant";

export const shouldDisplayBatteryInfo = (getUserRole) => {
    return (isUserAdmin(getUserRole && getUserRole?.Role) ||
            isUserSupport(getUserRole && getUserRole?.Role)) ||
            getUserRole?.privileges?.includes(userPrivileges.VehicleStatus);
}